import React from "react";

import { Spinner } from "./StudioControls";

const GLYPH = { done: "✓", failed: "✕", pending: "" };
const STATUS_TEXT = { done: "done", active: "in progress", failed: "failed", pending: "waiting" };

export const getJobSteps = progress => (progress && Array.isArray(progress.steps) ? progress.steps : []);

// Live checklist of a background AI job, published by the backend as it runs.
export const JobSteps = ({ steps }) => {
  if (!steps.length) return null;
  return (
    <ol className="cs-job-steps">
      {steps.map(step => (
        <li key={step.key} className={`is-${step.status}`}>
          <span className="cs-job-steps__marker" aria-hidden="true">
            {step.status === "active" ? <Spinner /> : GLYPH[step.status]}
          </span>
          <span className="cs-job-steps__label">{step.label}</span>
          <span className="cs-visually-hidden">, {STATUS_TEXT[step.status] || step.status}</span>
        </li>
      ))}
    </ol>
  );
};

// Progress panel: the running step as the headline, the checklist below it.
export const JobProgress = ({ progress, fallbackTitle }) => {
  const steps = getJobSteps(progress);
  const activeIndex = steps.findIndex(step => step.status === "active");
  const doneCount = steps.filter(step => step.status === "done").length;
  const current = activeIndex >= 0 ? steps[activeIndex] : null;

  return (
    <div className="cs-progress-panel cs-progress-panel--job" role="status">
      <div className="cs-progress-panel__head">
        <Spinner />
        <div>
          <p className="cs-strong">{current ? `${current.label}…` : fallbackTitle}</p>
          <p className="cs-muted">
            {steps.length ? `Step ${activeIndex >= 0 ? activeIndex + 1 : doneCount} of ${steps.length} · ` : "Starting · "}
            {progress && progress.detail ? `${progress.detail} · ` : ""}
            updates automatically · you can leave this page
          </p>
        </div>
      </div>
      {steps.length > 0 && (
        <React.Fragment>
          <div className="cs-job-bar" aria-hidden="true">
            <span style={{ width: `${Math.round((doneCount / steps.length) * 100)}%` }} />
          </div>
          <JobSteps steps={steps} />
        </React.Fragment>
      )}
    </div>
  );
};
